import { render, staticRenderFns } from "./SvgValueBar.vue?vue&type=template&id=24def31f&scoped=true&"
import script from "./SvgValueBar.vue?vue&type=script&lang=js&"
export * from "./SvgValueBar.vue?vue&type=script&lang=js&"
import style0 from "./SvgValueBar.vue?vue&type=style&index=0&id=24def31f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24def31f",
  null
  
)

export default component.exports